import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material';
import { AlarmMode } from './types';

interface Props {
  alarmMode: AlarmMode | undefined;
  disabled: boolean;
  handleAlarmModeChanged: (event: SelectChangeEvent<number>) => void;
}

const AlarmModeSelector = ({
  alarmMode,
  disabled,
  handleAlarmModeChanged,
}: Props) => {
  return (
    <FormControl variant='outlined' size='small' fullWidth>
      <InputLabel id='mode-label'>Alarm Mode</InputLabel>
      <Select
        id='mode'
        name='mode'
        label='Alarm Mode'
        fullWidth
        required
        value={alarmMode || 0}
        onChange={handleAlarmModeChanged}
        disabled={disabled}
      >
        <MenuItem value={0} key={0}>
          All
        </MenuItem>
        <MenuItem value={1} key={1}>
          Any
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default AlarmModeSelector;
